import { useEffect, useState } from 'react';

import { ContactPayload } from '../types';
import { fetchContactInfo } from '../services/contactService';

export const useContact = () => {
  const [contact, setContact] = useState<ContactPayload | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadContact = async () => {
      try {
        const contactData = await fetchContactInfo();
        if (isMounted) {
          setContact(contactData);
        }
      } catch (error) {
        console.error('Failed to load contact info', error);
      }
    };

    loadContact();

    return () => {
      isMounted = false;
    };
  }, []);

  return { contact };
};

